import React from 'react'
import PropTypes from 'prop-types';
import find from 'lodash/find'

import { CheckoutSection, hiddenAnchorStyle } from '../../components'
import { translateResourceString } from '../../../util/translationUtility';

import { Fade } from '../../componentAnimations'

import AddressSelectorList from './AddressSelectorList'
import AddressDisplay from './AddressDisplay'
import AddressEditorContainer from './AddressEditorContainer'

import { AddressShape, AddressActionCreatorsShape as AddressActionCreators } from './propTypes'

class CheckoutAddressComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listCollapsed: props.selectedAddressId ? true : false,
            editId: ''
        };
        this.onClickCollapse = this.onClickCollapse.bind(this);
        this.onDoneSelecting = this.onDoneSelecting.bind(this);
        this.onBeginEdit = this.onBeginEdit.bind(this);
        this.onEndEdit = this.onEndEdit.bind(this);
        this.onEditCancel = this.onEditCancel.bind(this);
    }

    onClickCollapse(e) {
        e.preventDefault();
        this.setState({ listCollapsed: !this.state.listCollapsed });
    }

    onDoneSelecting() {
        this.setState({ listCollapsed: true });
    }

    onBeginEdit(Id) {
        this.setState({ editOpen: true, editId: Id, listCollapsed: true });
    }

    onEndEdit(Id) {
        this.setState({ editOpen: false });
        this.props.onEndEdit(Id);
    }

    onEditCancel() {
        this.setState({ editOpen: false, listCollapsed: false })
    }

    render() {
        const selectedAddress = find(this.props.addresses, address => address && address.Id === this.props.selectedAddressId);

        let editAddressButtonText = translateResourceString("/Checkout/Address/DoneButton");
        if (this.state.listCollapsed) {
            editAddressButtonText = this.props.allowAdding ? translateResourceString("/Checkout/Address/AddEditAddressesButton")
                                                           : translateResourceString("/Checkout/Address/EditAddressButton");
        }

        return (
            <Fade inProp={!this.props.hidden}>
                <CheckoutSection label={this.props.sectionLabel + ""} toolTip={this.props.toolTip} hidden={this.props.hidden}>
                
                    <div className='row no-gutters' style={{ minHeight: '2em' }}>
                        <div className='col-12 bg-grey-light p-2 d-flex justify-content-between'>
                            <AddressDisplay
                                    address={selectedAddress}
                                    compact={true}
                           />
                         {this.props.allowSelect && this.props.addresses && this.props.addresses.length > 1 &&
                            <div
                                className="link-base"
                                style={{cursor: 'pointer'}}
                                onClick={(e) => this.onClickCollapse(e)}>
                                <span>{editAddressButtonText}</span>
                                &nbsp;
                                <span className='fa fa-edit'/>
                            </div>
                        }
                        </div>
                    </div>
                    {this.props.allowBillingEqualsShipping && this.props.onUseForAnotherClicked &&
                        <div className='row' style={{ minHeight: '2em' }}>
                            <div className='col-12 bg-grey-light p-2'>
                                <div>
                                    <span
                                        onClick={this.props.onUseForAnotherClicked}
                                    >
                                        <input
                                            style={{ marginRight: 5 }}
                                            type='checkbox'
                                            checked={this.props.useForAnotherSelected}
                                            id='useForAnother'
                                            readOnly={true}
                                        />
                                        <label
                                            htmlFor='#useForAnother'
                                        >
                                            {this.props.useForAnotherMessage}
                                        </label>
                                    </span>
                                </div>
                            </div>
                        </div>
                    }
                    {this.props.allowEdit &&
                        <React.Fragment>
                            {this.state.editOpen
                                ? (
                                    <React.Fragment>
                                        <hr style={{ width: '90%' }} />
                                        <AddressEditorContainer
                                            addressId={this.state.editId}
                                            addressActionCreators={this.props.addressActionCreators}
                                            addressType={this.props.addressType}
                                            onAddressCreated={this.onEndEdit}
                                            onAddressUpdated={this.onEndEdit}
                                            onEditCancel={this.onEditCancel}
                                        />
                                    </React.Fragment>
                                )
                                : (
                                    <React.Fragment>
                                        <Fade inProp={!this.state.listCollapsed}>
                                            <AddressSelectorList
                                                addressActionCreators={this.props.addressActionCreators}
                                                addresses={this.props.addresses}
                                                allowAdding={this.props.allowAdding}
                                                onBeginEdit={this.onBeginEdit}
                                                onDoneSelecting={this.onDoneSelecting}
                                                selectedAddressId={this.props.selectedAddressId} selectAddressMessage={this.props.selectAddressMessage} />
                                        </Fade>
                                    </React.Fragment>
                                )}
                        </React.Fragment>
                    }

                    {this.props.allowSelect &&
                        <React.Fragment>
                            <Fade inProp={!this.state.listCollapsed}>
                                <AddressSelectorList
                                    addressActionCreators={this.props.addressActionCreators}
                                    addresses={this.props.addresses}
                                    allowAdding={this.props.allowAdding}
                                    onBeginEdit={this.onBeginEdit}
                                    onDoneSelecting={this.onDoneSelecting}
                                    selectedAddressId={this.props.selectedAddressId} selectAddressMessage={this.props.selectAddressMessage} />
                            </Fade>
                        </React.Fragment>
                    }
                    
                </CheckoutSection>
            </Fade>
        );
    }
}

CheckoutAddressComponent.propTypes = {
    addressActionCreators: AddressActionCreators.propTypes,
    addressType: PropTypes.number.isRequired,
    addresses: PropTypes.arrayOf(AddressShape.propTypes).isRequired,
    allowAdding: PropTypes.bool.isRequired,
    onEndEdit: PropTypes.func.isRequired,
    onUseForAnotherClicked: PropTypes.func,
    sectionLabel: PropTypes.string.isRequired,
    selectAddressMessage: PropTypes.string.isRequired,
    selectedAddressId: PropTypes.string,
    useForAnotherMessage: PropTypes.string,
    useForAnotherSelected: PropTypes.bool,
    allowBillingEqualsShipping: PropTypes.bool
}

export default CheckoutAddressComponent;